import { Zap } from "lucide-react";

const ITEMS = [
  "Pre-order now — ride in 1–4 weeks",
  "HitWay · Sur-Ron · Talaria · OSET",
  "Road-legal range — EN 15194 certified",
  "Kids bikes from age 4 up",
  "One honest price — delivery included",
  "Family bundle deals available",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-lg font-bold uppercase tracking-wide text-sand/60 sm:text-xl">
          {item}
        </span>
        <Zap className="h-3.5 w-3.5 shrink-0 text-brass" strokeWidth={2} fill="currentColor" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-border bg-forest py-4">
    <div className="flex w-max animate-marquee-drift">
      <Row />
      <Row />
    </div>
  </div>
);
